<form
	class="sdp-saml-wizard-form"
	novalidate
>
	<div class="sdp-clear"></div>
	<div>
		<div class="sdp-saml-download-spacer">
			<div class="sdp-saml-wizard-download-text-label">
				{{ "applications.label.name" | translate}} :
			</div>
			<div class="sdp-saml-wizard-download-text-value sdp-ellipsis">
				{{ applicationState.application.name }}
			</div>
			<div class="sdp-clear"></div>
		</div>
		<div *ngIf="applicationState.application.selectType === 'website'; then showWebsite else showNetworkService"></div>
		<ng-template #showWebsite>
			<div class="sdp-saml-download-spacer">
				<div class="sdp-saml-wizard-download-text-label">
					{{ "applications.label.webUrl" | translate}} :
				</div>
				<div class="sdp-saml-wizard-download-text-value sdp-ellipsis">
					{{ applicationState.webUrl }}
				</div>
				<div class="sdp-clear"></div>
			</div>
		</ng-template>
		<ng-template #showNetworkService>
			<div class="sdp-saml-download-spacer">
				<div class="sdp-saml-wizard-download-text-label">
					{{ "applications.label.ip" | translate}} :
				</div>
				<div class="sdp-saml-wizard-download-text-value sdp-ellipsis">
					{{ applicationState.application.ip }}
				</div>
				<div class="sdp-clear"></div>
			</div>
			<div class="sdp-saml-download-spacer">
				<div class="sdp-saml-wizard-download-text-label">
					{{ "applications.label.portNumber" | translate}} :
				</div>
				<div class="sdp-saml-wizard-download-text-value sdp-ellipsis">
					<div *ngFor="let port of applicationState.application.ports">
						{{ prettyPrintPort(port) }}
					</div>
				</div>
				<div class="sdp-clear"></div>
			</div>
		</ng-template>
		<div class="sdp-saml-download-spacer">
			<div class="sdp-saml-wizard-download-text-label">
				{{ "applications.label.image" | translate}} :
			</div>
			<div class="sdp-saml-wizard-download-text-value sdp-ellipsis">
				<sdp-application-image
					[applicationImage]="applicationImage"
					size="small"
				></sdp-application-image>
			</div>
			<div class="sdp-clear"></div>
		</div>
		<div class="sdp-clear"></div>
	</div>
</form>